export default "__VITE_ASSET__Cz4nLf6r__"